<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters class="px-3 table__headers">
      <v-col cols="8" class="d-flex align-center">
        <span
          class="body-regular-smaller neutral-20-dark--text font-weight-medium"
        >
          {{ $t('message.playlist.settings.tabs.videos.name') }}
        </span>
      </v-col>
      <v-col class="d-flex align-center">
        <span
          class="body-regular-smaller neutral-20-dark--text font-weight-medium"
        >
          {{ $t('message.playlist.settings.tabs.videos.duration') }}
        </span>
      </v-col>
      <v-col class="d-flex align-center justify-center">
        <span
          class="body-regular-smaller neutral-20-dark--text font-weight-medium"
        >
          {{ $t('message.playlist.settings.tabs.videos.remove') }}
        </span>
      </v-col>
      <v-col class="d-flex align-center justify-center">
        <span
          class="body-regular-smaller neutral-20-dark--text font-weight-medium text-center"
        >
          &nbsp;
        </span>
      </v-col>
    </v-row>
    <v-row no-gutters class="table__data" v-if="playlists_videos.length">
      <v-row
        no-gutters
        v-for="(video, index) in playlists_videos"
        :key="`tab__video-item-${index}`"
        class="table__video-item"
      >
        <v-col
          class="d-flex align-center text-truncate"
          cols="8"
          style="max-width: 100%"
        >
          <simple-svg :src="require('@/assets/playBoxOutline.svg')" />
          <span
            class="neutral-40-light--text body-regular-small ml-2 text-truncate"
            >{{ videosInfo[video.video_id].title || video.video_id }}</span
          >
        </v-col>
        <v-col class="d-flex align-center">
          <span class="neutral-40-light--text body-regular-small ml-2">{{
            videosInfo[video.video_id]
              ? formatTime(videosInfo[video.video_id].length)
              : '-'
          }}</span>
        </v-col>
        <v-col class="d-flex justify-center">
          <v-icon
            color="feedback-danger"
            size="16"
            @click="handleRemoveVideo(index)"
            :disabled="loadings.saveChanges"
            >panda-remove</v-icon
          >
        </v-col>
        <v-col class="d-flex justify-center align-center">
          <div class="d-none sort-container">
            <v-icon
              color="neutral"
              size="16"
              @click="handleMoveUpVideoOrder(index)"
              :disabled="loadings.saveChanges"
              >mdi-chevron-up</v-icon
            >
            <v-icon
              color="neutral"
              size="16"
              @click="handleMoveDownVideoOrder(index)"
              :disabled="loadings.saveChanges"
              >mdi-chevron-down</v-icon
            >
          </div>
        </v-col>
      </v-row>
    </v-row>
    <p
      @click="openModal"
      class="my-6 body-regular-small brand-60-base--text font-weight-medium pointer"
    >
      {{ $t('message.playlist.settings.tabs.videos.add') }}
    </p>
    <v-row no-gutters>
      <div class="save-action-divider"></div>
      <v-col cols="12" class="my-6">
        <div class="d-flex justify-end px-6">
          <base-btn type="tertiary" @click="true">
            {{ $t('message.actions.cancel') }}
          </base-btn>
          <base-btn
            :disabled="!hasChanges || loadings.saveChanges"
            :loading="loadings.saveChanges"
            @click="handleSaveChanges"
            class="ml-2"
          >
            {{ $t('message.actions.save') }}
          </base-btn>
        </div>
      </v-col>
    </v-row>
    <AddVideoPlaylist
      :playlistId="playlist.id"
      :dialogVisible="dialogVisible"
      @update:dialogVisible="dialogVisible = $event"
    />
  </v-container>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import AddVideoPlaylist from '../Modals/AddVideo.vue'
import _ from 'lodash'
import playlistApi from '@/services/playlistApi'
import formatTimeMixin from '@/utils/formatTime.mixins.js'

export default {
  name: 'VideosTab',
  components: {
    AddVideoPlaylist,
  },
  mixins: [formatTimeMixin],
  data() {
    return {
      internalDialogVisible: false,
      dialogVisible: false,
      initPlaylistVideos: [],
      loadings: {
        saveChanges: false,
      },
      videosInfo: {},
    }
  },
  watch: {
    playlists_videos() {
      this.getVideosInfo()
    },
  },
  computed: {
    ...mapState({
      playlists_videos: (state) => state.playlist.playlists_videos,
      playlist: (state) => state.playlist.playlist,
    }),
    hasChanges() {
      return !_.isEqual(this.initPlaylistVideos, this.playlists_videos)
    },
  },
  methods: {
    ...mapMutations('playlist', ['UPDATE_PLAYLIST_VIDEOS']),
    getVideosToBeRemoved() {
      return this.initPlaylistVideos.filter((item) => {
        const video = this.playlists_videos.find(
          (video) => video.video_id === item.video_id
        )
        if (video) return false
        return true
      })
    },
    async handleSaveChanges() {
      this.loadings.saveChanges = true
      try {
        const videosToBeRemoved = this.getVideosToBeRemoved()
        const hasVideosToBeRemoved = videosToBeRemoved.length
        if (hasVideosToBeRemoved) {
          const promises = videosToBeRemoved.map((video) =>
            playlistApi.removePlaylistVideos(video.playlist_id, video.video_id)
          )
          await Promise.all(promises)
        }
        if (this.playlists_videos.length) {
          const { data } = await playlistApi.updatePlaylistVideos(
            this.playlists_videos,
            this.playlist.id
          )
          if (data) {
            this.UPDATE_PLAYLIST_VIDEOS(data)
          }
          this.initPlaylistVideos = [...this.playlists_videos]
        }
        this.showSuccessSnackbarAlert()
      } catch (error) {
        console.error('Error saving changes: ', error)
        this.showErrorSnackbarAlert(
          error?.response?.data?.errMsg ?? error?.response?.status
        )
      }
      this.loadings.saveChanges = false
    },
    handleGoBack() {
      this.$router.push({ name: 'Playlists' })
    },
    async getVideosInfo() {
      const videosIds = this.playlists_videos.map((video) => video.video_id)
      let videosInfo = await window.db.videos
        .where('id')
        .anyOf(videosIds)
        .toArray()
      const videosInfoFinal = {}
      videosInfo.forEach((video) => {
        videosInfoFinal[video.id] = video
      })
      this.videosInfo = videosInfoFinal
    },
    showSuccessSnackbarAlert() {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: this.$t('message.pages.video.changesSaved'),
        type: 'success',
      })
    },
    showErrorSnackbarAlert(errMsg = '') {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: `${this.$t('message.error')}: ${errMsg}`,
        type: 'error',
      })
    },
    handleMoveUpVideoOrder(index) {
      let playlists_videos = [...this.playlists_videos]
      if (index - 1 <= -1) return

      playlists_videos[index - 1].order += 1
      playlists_videos[index].order -= 1

      playlists_videos = playlists_videos.sort((past, current) => {
        return past.order - current.order
      })
      this.UPDATE_PLAYLIST_VIDEOS(playlists_videos)
    },
    handleMoveDownVideoOrder(index) {
      let playlists_videos = [...this.playlists_videos]
      if (index + 1 >= playlists_videos.length) return
      playlists_videos[index].order += 1
      playlists_videos[index + 1].order -= 1

      playlists_videos = playlists_videos.sort((past, current) => {
        return past.order - current.order
      })
      this.UPDATE_PLAYLIST_VIDEOS(playlists_videos)
    },
    handleRemoveVideo(index) {
      let playlists_videos = [...this.playlists_videos]

      playlists_videos.splice(index, 1)

      this.UPDATE_PLAYLIST_VIDEOS(playlists_videos)
    },
    openModal() {
      this.dialogVisible = true
    },
  },
  mounted() {
    this.initPlaylistVideos = [...this.playlists_videos]
    this.getVideosInfo()
  },
}
</script>

<style lang="scss" scoped>
.text-truncate {
  min-width: 0;
}
.table {
  &__headers {
    height: 48px;
    border-bottom: 1px solid varFigma(neutral-95-lightest);
  }

  &__data {
    max-height: 480px;
    overflow-y: auto;
    flex-direction: column;
  }

  &__video-item {
    border-bottom: 1px solid varFigma(neutral-95-lightest);
    padding: 12px 8px;
    flex-wrap: nowrap;
    .sort-container {
      .v-icon {
        height: 16px;
      }
    }
    &:hover {
      .sort-container {
        display: flex !important;
      }
    }
  }
}
</style>
